import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SidebarLogo from './sidebarComponents/SidebarLogo';
import sidebarMenuConfig,  { filterSidebarByRole } from './sidebarComponents/sidebarManuConfig';
import { useSidebar } from '../../context/SidebarContext';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import FeatherIcon from 'feather-icons-react';
import { getUserInfo } from '../../utils/token';

const Sidebar = () => {
  const [expandedMenus, setExpandedMenus] = useState({});
  const { isCollapsed } = useSidebar();
  const { role } = getUserInfo(); 

  const filteredMenu = filterSidebarByRole(sidebarMenuConfig, role);

  const toggleMenu = (menuId) => {
    setExpandedMenus((prev) => ({
      ...prev,
      [menuId]: !prev[menuId]
    }));
  };

  const renderMenuItems = (items, parentId = '') => {
    return items.map((item) => {
      if (item.children) {
        return (
          <li className="nav-item" key={item.id}>
            <button
              className="nav-link menu-link btn w-100 text-start"
              onClick={() => toggleMenu(item.id)}
              aria-expanded={!!expandedMenus[item.id]}
              aria-controls={item.id}
            >
              {<FeatherIcon icon={item.icon} />} <span>{item.title || item.label}</span>
            </button>
            <div
              className={`collapse menu-dropdown ${expandedMenus[item.id] ? 'show' : ''}`}
              id={item.id}
            >
              <ul className="nav nav-sm flex-column">
                {renderMenuItems(item.children, item.id)}
              </ul>
            </div>
          </li>
        );
      } else {
        return (
          <li className="nav-item" key={item.to}>
            <Link to={item.to} className="nav-link">
              {item.label}
            </Link>
          </li>
        );
      }
    });
  };

  return (
    <>
      <div className={`app-menu navbar-menu ${isCollapsed ? 'collapsed' : ''}`}>
        <SidebarLogo />

          <div id="scrollbar">
            <div className="container-fluid">
              <div id="two-column-menu"></div>
              <ul className="navbar-nav" id="navbar-nav">
                <li className="menu-title">
                  <span data-key="t-menu">Menu</span>
                </li>
                {filteredMenu.map((section) => (
                  <React.Fragment key={section.id}>
                    {renderMenuItems([section])}
                  </React.Fragment>
                ))}
              </ul>
            </div>
          </div>
  
        <div className="sidebar-background"></div>
      </div>
      <div className="vertical-overlay"></div>
    </>
    
  );
};

export default Sidebar;
